








	import { GetInventoryResponse } from '@/classes/TayehApi/Instance';
import {
		Component,
		Prop,
		Vue
	} from 'vue-property-decorator';

	@Component({
		inheritAttrs: false,
		components: {
			'small-info': () => import('./ShopInventorySmallInfo.vue')
		},
	})
	export default class ShopInventoryAcardion extends Vue {
		@Prop() private readonly inventories: Array < GetInventoryResponse > ;
	}
